// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { FormGroup, NumericInput, Intent } from '@blueprintjs/core';
import classNames from 'classnames';

import { CellType } from '@/constants';
import { CLASSES } from '@/constants/classes';

/**
 * Numeric input table cell.
 */
export default function NumericInputCell({
  row: { index },
  column: { id },
  cell: { value: initialValue },
  payload,
}) {
  const [value, setValue] = useState(initialValue);

  const handleValueChange = (newValue, valueAsString) => {
    if (valueAsString === '') {
      setValue('');
      return;
    }

    if (Number.isNaN(newValue)) {
      setValue(valueAsString);
      return;
    }
    setValue(valueAsString);
  };
  const onBlur = () => {
    const parsedValue = parseFloat(value);
    payload.updateData(index, id, Number.isFinite(parsedValue) ? parsedValue : '');
  };
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const error = payload.errors?.[index]?.[id];

  return (
    <FormGroup
      intent={error ? Intent.DANGER : null}
      className={classNames(CLASSES.FILL)}
    >
      <NumericInput
        value={value}
        onValueChange={handleValueChange}
        onBlur={onBlur}
        fill={true}
        buttonPosition={'none'}
        clampValueOnBlur={false}
      />
    </FormGroup>
  );
}

NumericInputCell.cellType = CellType.Field;